import { useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom'
import { toast } from 'react-toastify'

export function useRouter<TParams extends { [K in keyof TParams]?: string } = {}>() {
  const history = useHistory()
  const location = useLocation()
  const params = useParams<TParams>()
  const match = useRouteMatch()

  return {
    history,
    location,
    match,
    params,
  }
}

export function useHistoryPush() {
  const { history } = useRouter()

  const push = (path: string, clearNotifications: boolean = true) => {
    if (clearNotifications) {
      toast.dismiss()
    }
    history.push(path)
  }
  return push
}
